<template>
  <el-collapse
    ref="collapseRef"
    v-model="activeNames"
  >
    <el-collapse-item
      v-for="(item, index) in groups"
      :name="index"
      :key="index"
    >
      <template #title>
        <div
          v-if="isMobileDevices"
          class="title-group"
        >
          {{ item.name }}&nbsp;&nbsp;{{ t('order.paymentDate') + ': ' + item.paymentDate }}&nbsp;&nbsp;{{ t('bank.totalAmount') + ': ' + formatThousands(item.totalAmount) + ' ' + item.currency }}
        </div>
        <div
          v-else
          class="title-group"
        >
          <el-row>
            <el-col
              :span="4"
            >
              <span class="title-left">{{ item.name }}</span>
            </el-col>
            <el-col
              :span="12"
              class="hidden-md-and-down"
            />
            <el-col
              :span="4"
              class="title-center"
            >
              <span class="title-right-item">{{ t('order.paymentDate') + ': ' + item.paymentDate }}</span>
            </el-col>
            <el-col
              :span="4"
              class="title-right"
            >
              <span class="title-right-item">{{ t('bank.totalAmount') + ': ' + formatThousands(item.totalAmount) + ' ' + item.currency }}</span>
            </el-col>
          </el-row>
        </div>
      </template>
      <SimpleTable
        :ref="(el) => setChildRef(el, index)"
        :listLoading="listLoading"
        :tableData="item.tableList"
        :columnStruct="columnStruct"
        :hadSelect="tableHadSelect"
        :hadOperate="false"
        :selectable="selectable"
      />
    </el-collapse-item>
  </el-collapse>
</template>
<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { ElCollapse } from 'element-plus'
import resize from '@/layout/resize'
import { formatThousands } from '@/utils'

type SimpleTableRef = {
  getSelectionRows: () => any[]
  clearSelection?: () => void
}

export default defineComponent({
  name: 'DynamicCollapse',
  components: {
    SimpleTable
  },
  methods: { formatThousands },
  props: {
    groups: {
      type: Array,
      required: true,
      default: () => []
    },
    columnStruct: {
      type: Array,
      required: true
    },
    tableHadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultAllActive: {
      type: Boolean,
      required: false,
      default: true
    },
    defaultActive: {
      type: Array,
      default: () => []
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  // 定义 v-model
  emits: ['update:groups'],
  setup(props) {
    const { t } = useI18n()
    const collapseRef = ref(ElCollapse)
    const tableList = ref()
    const { isMobile } = resize()
    const isMobileDevices = computed(() => {
      return isMobile()
    })
    const activeNames = computed<any[]>(() => {
      if (props.defaultAllActive) {
        return Array.from(props.groups.keys()) || []
      } else {
        return props.defaultActive
      }
    })

    // 存储所有 SimpleTable 实例的 ref
    const simpleTableRefs = ref<InstanceType<typeof SimpleTable>[]>([])

    // 设置 ref 的方法
    const setChildRef = (el: InstanceType<typeof SimpleTable> | null, index: number) => {
      if (el) {
        simpleTableRefs.value[index] = el
      } else {
        simpleTableRefs.value[index] = null as any
      }
    }

    // 获取所有选中行
    const getSelectionRows = () => {
      const allSelectedRows: any[] = []
      const selectedRowsByGroup: Record<number, any[]> = {}

      simpleTableRefs.value.forEach((tableRef, index) => {
        if (tableRef && typeof (tableRef as any).getSelectionRows === 'function') {
          try {
            const rows = (tableRef as any).getSelectionRows()
            if (rows && rows.length > 0) {
              allSelectedRows.push(...rows)
              selectedRowsByGroup[index] = rows
            }
          } catch (error) {
            console.error(`获取第 ${index} 个表格的选中行失败:`, error)
          }
        }
      })

      return {
        allRows: allSelectedRows,
        byGroup: selectedRowsByGroup,
        totalCount: allSelectedRows.length
      }
    }

    // 监听 groups 变化，更新 ref 数组长度
    watch(() => props.groups, (newGroups) => {
      simpleTableRefs.value = new Array(newGroups.length).fill(null)
    }, { immediate: true })

    return {
      t,
      collapseRef,
      setChildRef,
      tableList,
      activeNames,
      isMobileDevices,
      getSelectionRows
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>

:deep(.el-collapse-item__header) {
  color: #000000 !important;
  flex: 1 0 auto !important;
  order: -1 !important;
  background-color: #FFFFFF !important
}

.title-group {
  //display: flex;
  //justify-content: space-between; /* 左右分布 */
  //align-items: center; /* 垂直居中 */
  width: 100%;
  flex: 1 0 90%;
  order: 1;

  //.title-left {
  //  flex-shrink: 0; /* 防止被压缩 */
  //  font-weight: bold;
  //  color: #000000;
  //}

  //.title-right {
  //  display: flex;
  //  gap: 20px; /* 右边两个span之间的间距 */
  //  margin-right: 20px;
  //
  //  .title-right-item {
  //    color: #000000;
  //    font-weight: bold;
  //  }
  //}
}
@media (max-width: 768px) {
  .title-group {
    width: 100%;
    white-space: nowrap; /* 防止文本换行 */
    overflow-x: auto; /* 隐藏溢出的文本 */
  }
}
</style>
